<div class="wrapper flex flex-col justify-between">
  <div class="heading text-type-2 mb-[20px] flex flex-row items-center justify-between">
    <div>{{ data?.editPackage?.package_number || 'Create Package' }}</div>
    @if (data?.editPackage?.id) {
      <button (click)="deletePackage()" class="delete-icon-button" aria-label="Delete package">
        <mat-icon svgIcon="trash" class="text-red-500" />
      </button>
    }
  </div>

  <div class="details flex-1 pt-[20px]">
    <app-text-input
      (checkForErrors)="checkForErrors($event)"
      [error]="errorMessages['title']"
      [parentFormGroup]="form"
      class="w-full mb-[20px]"
      controlName="title"
      label="title"
    />
    <app-text-area
      (checkForErrors)="checkForErrors($event)"
      [error]="errorMessages['description']"
      [parentFormGroup]="form"
      class="w-full mb-[20px]"
      controlName="description"
      label="description"
    />
    @if (warrantyOptions.length > 1) {
      <app-dropdown
        (checkForErrors)="checkForErrors($event)"
        [error]="errorMessages['warranty_id']"
        [options]="warrantyOptions"
        [parentFormGroup]="form"
        class="w-full mb-[20px]"
        controlName="warranty_id"
        label="warranty"
      />
    }
    <app-dropdown
      (checkForErrors)="checkForErrors($event)"
      [error]="errorMessages['sent_to_contractor_id']"
      [options]="contractorOptions"
      [parentFormGroup]="form"
      class="w-full mb-[20px]"
      controlName="sent_to_contractor_id"
      label="prime contractor"
    />
    <app-date-picker
      (checkForErrors)="checkForErrors($event)"
      [error]="errorMessages['due_date']"
      [parentFormGroup]="form"
      class="w-full mb-[20px]"
      controlName="due_date"
      label="due date"
    />

    <!-- Claims list -->
    <div class="claims-section mb-[20px]">
      <div class="section-header flex items-center justify-between mb-[12px]">
        <div class="flex items-center gap-[8px]">
          <span class="section-label">Claims</span>
          @if (claims.length) {
            <span class="count-badge">{{ claims.length }}</span>
          }
        </div>
        <button class="add-claims-button" (click)="toggleClaimPicker()">
          <mat-icon class="add-icon">{{ showClaimPicker ? 'expand_less' : 'add' }}</mat-icon>
          <span>{{ showClaimPicker ? 'Hide' : 'Add Claims' }}</span>
        </button>
      </div>

      <!-- Claim Picker -->
      @if (showClaimPicker) {
        <div class="claim-picker mb-[12px]">
          @if (availableClaimsLoading) {
            <div class="text-type-14 text-[#60698B] py-[8px]">Loading claims...</div>
          } @else if (availableClaims.length === 0) {
            <div class="text-type-14 text-[#60698B] py-[8px]">No available claims found.</div>
          } @else {
            @for (claim of availableClaims; track claim.id) {
              <div class="picker-item flex items-center gap-[12px] mb-[6px]"
                   [class.disabled]="isClaimAlreadyAdded(claim.id)">
                <mat-checkbox
                  [checked]="isClaimAlreadyAdded(claim.id)"
                  [disabled]="isClaimAlreadyAdded(claim.id)"
                  (change)="addClaim(claim)"
                  color="primary"
                ></mat-checkbox>
                <div class="flex-1">
                  <div class="text-type-11">{{ claim.claim_number }} - {{ claim.title }}</div>
                  <div class="flex items-center gap-[6px] mt-[2px]">
                    @if (claim.severity && severityMap[claim.severity]) {
                      <span
                        [ngClass]="[severityMap[claim.severity].bgColor, severityMap[claim.severity].textColor]"
                        class="severity-badge px-[6px] rounded-full text-[11px]">
                        {{ severityMap[claim.severity].label }}
                      </span>
                    }
                    <span class="text-type-14 text-[#60698B]">{{ claim.status }}</span>
                  </div>
                </div>
              </div>
            }
          }
        </div>
      }

      @if (claims.length === 0 && !showClaimPicker) {
        <div class="text-type-14 text-[#60698B] py-[12px]">No claims added to this package.</div>
      }
      @for (claim of claims; track claim.id) {
        <div class="claim-item flex flex-col gap-[4px] mb-[8px]">
          <div class="flex items-start justify-between">
            <div class="claim-info flex-1">
              <div class="claim-title text-type-11">{{ claim.claim_number }} - {{ claim.title }}</div>
              <div class="claim-meta flex items-center gap-[8px] mt-[4px] flex-wrap">
                @if (claim.severity && severityMap[claim.severity]) {
                  <span
                    [ngClass]="[severityMap[claim.severity].bgColor, severityMap[claim.severity].textColor]"
                    class="severity-badge px-[8px] rounded-full">
                    {{ severityMap[claim.severity].label }}
                  </span>
                }
                @if (claim.status) {
                  <span class="status-badge px-[8px] rounded-full">{{ claim.status }}</span>
                }
                @if (claim.claim_type) {
                  <span class="text-type-14 text-[#60698B]">{{ claim.claim_type }}</span>
                }
              </div>
            </div>
            <button class="remove-button" (click)="removeClaim(claim)" aria-label="Remove claim">
              <mat-icon>close</mat-icon>
            </button>
          </div>
          @if (claim.description) {
            <div class="text-type-14 text-[#60698B] mt-[2px]">{{ claim.description }}</div>
          }
          @if (claim.pictures?.length) {
            <div class="flex gap-[6px] mt-[4px] flex-wrap">
              @for (pic of claim.pictures; track pic.id) {
                <img [src]="pic.thumb_url || pic.original_url" class="claim-thumbnail" alt="Claim photo" />
              }
            </div>
          }
        </div>
      }
    </div>
  </div>

  <div class="action-section mb-[5px] flex flex-row gap-[20px] w-full">
    <app-secondary-button (handleClick)="save()" [isDisabled]="!form.valid || isSaving" class="flex-1">Save Draft
    </app-secondary-button>
    <app-primary-button (handleClick)="send()" [isDisabled]="!form.valid || claims.length === 0 || isSaving" class="flex-1">Send
    </app-primary-button>
  </div>
</div>
